import type { Member, RoleOption } from '../types';

export const membersMock: Member[] = [
  {
    id: 'member-1',
    userId: 'user-1',
    displayName: 'Juan Pérez',
    email: 'juan.perez@company.com',
    avatarUrl: null,
    role: 'owner',
    isActive: true,
    areaId: 'unit-1',
    clientId: null,
    tenantId: 'tenant-1',
    expiresAt: null,
    createdAt: '2024-01-15T10:00:00Z',
    isCurrentUser: false,
  },
  {
    id: 'member-2',
    userId: 'user-2',
    displayName: 'María García',
    email: 'maria.garcia@company.com',
    avatarUrl: null,
    role: 'admin',
    isActive: true,
    areaId: 'unit-2',
    clientId: null,
    tenantId: 'tenant-1',
    expiresAt: null,
    createdAt: '2024-02-20T14:30:00Z',
    isCurrentUser: true,
  },
  {
    id: 'member-3',
    userId: 'user-3',
    displayName: 'Carlos López',
    email: 'carlos.lopez@company.com',
    avatarUrl: null,
    role: 'collaborator',
    isActive: true,
    areaId: 'unit-1',
    clientId: null,
    tenantId: 'tenant-1',
    expiresAt: '2025-12-31T23:59:59Z',
    createdAt: '2024-03-10T09:00:00Z',
    isCurrentUser: false,
  },
  {
    id: 'member-4',
    userId: 'user-4',
    displayName: 'Ana Martínez',
    email: 'ana.martinez@company.com',
    avatarUrl: null,
    role: 'client',
    isActive: false,
    areaId: 'unit-3',
    clientId: null,
    tenantId: 'tenant-1',
    expiresAt: '2025-06-30T23:59:59Z',
    createdAt: '2024-04-05T11:00:00Z',
    isCurrentUser: false,
  },
  {
    id: 'member-5',
    userId: 'user-5',
    displayName: 'Pedro Sánchez',
    email: 'pedro.sanchez@company.com',
    avatarUrl: null,
    role: 'collaborator',
    isActive: true,
    areaId: 'unit-2',
    clientId: null,
    tenantId: 'tenant-1',
    expiresAt: null,
    createdAt: '2024-05-12T08:00:00Z',
    isCurrentUser: false,
  },
  {
    id: 'member-6',
    userId: 'user-6',
    displayName: 'Laura Rodríguez',
    email: 'laura.rodriguez@company.com',
    avatarUrl: null,
    role: 'collaborator',
    isActive: false,
    areaId: null,
    clientId: null,
    tenantId: 'tenant-1',
    expiresAt: null,
    createdAt: '2024-06-01T10:00:00Z',
    isCurrentUser: false,
  },
];

export const rolesMock: RoleOption[] = [
  { id: 'owner', name: 'Propietario', description: 'Acceso completo a la organización' },
  { id: 'admin', name: 'Administrador', description: 'Gestión de miembros y configuración' },
  { id: 'collaborator', name: 'Colaborador', description: 'Acceso a proyectos y tareas' },
  { id: 'client', name: 'Cliente', description: 'Acceso para clientes externos' },
];
